import { Yup } from "@pharmupp/p3-front-commons"
import { OpeningHoursEnum, WEEK_DAYS } from "./OpeningHours.const"

export const openingHoursSchema = Yup.object({
  [OpeningHoursEnum.OPENING_WEEK]: Yup.array().of(
    Yup.object({
      day: Yup.string()
        .oneOf([...WEEK_DAYS])
        .required(),
      [OpeningHoursEnum.ENABLE]: Yup.boolean(),
      [OpeningHoursEnum.OPENING]: Yup.object().when(OpeningHoursEnum.ENABLE, {
        is: true,
        then: (schema) =>
          schema.shape({
            [OpeningHoursEnum.START]: Yup.date().required("Début requis"),
            [OpeningHoursEnum.END]: Yup.date().required("Fin requise"),
          }),
      }),
      [OpeningHoursEnum.HAS_BREAK]: Yup.boolean(),
      [OpeningHoursEnum.WORK_BREAK]: Yup.object({
        [OpeningHoursEnum.START]: Yup.date(),
        [OpeningHoursEnum.END]: Yup.date(),
      }),
    }),
  ),
})

// Manual type definition because Yup's .when() doesn't infer conditional types correctly
export type OpeningHoursFormValues = {
  [OpeningHoursEnum.OPENING_WEEK]: Array<{
    day: (typeof WEEK_DAYS)[number]
    [OpeningHoursEnum.ENABLE]: boolean
    [OpeningHoursEnum.OPENING]?: {
      [OpeningHoursEnum.START]: Date
      [OpeningHoursEnum.END]: Date
    }
    [OpeningHoursEnum.HAS_BREAK]?: boolean
    [OpeningHoursEnum.WORK_BREAK]?: {
      [OpeningHoursEnum.START]: Date
      [OpeningHoursEnum.END]: Date
    }
  }>
}
